import { render, staticRenderFns } from "./groupsFormLessonItem.vue?vue&type=template&id=029f8d7b&"
import script from "./groupsFormLessonItem.vue?vue&type=script&lang=js&"
export * from "./groupsFormLessonItem.vue?vue&type=script&lang=js&"
import style0 from "./groupsFormLessonItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports